export default __webpack_public_path__ + "static/media/avatar_getwotty.41f1d623.png";